<template>
    <div class="cs-filter">
        <!-- Titlen tegnes af indpakningen, som også bærer sammenklapningen. -->

        <!--
            Fritekst inde i kategorien.

            Den lægger sig OVEN PÅ de øvrige filtre. Står man på Bundkort med
            AM5 valgt i socket og skriver "asus", får man de AM5-boards hvor der
            er noget med asus i specifikationerne, ikke alle asus-varer.

            Der ventes til man holder pause med at skrive. Ellers ville hvert
            tastetryk sende en ny forespørgsel gennem hele filtreringen.
        -->
        <form class="cs-filter__form" @submit.prevent="soegNu">
            <input
                v-model="tekst"
                type="search"
                class="cs-filter__input"
                :placeholder="`Fx ${eksempel}`"
                :aria-label="filter.translation_string_ident"
            />
            <button v-if="tekst" type="button" class="cs-filter__ryd" @click="ryd" aria-label="Ryd søgning">
                &times;
            </button>
        </form>

        <p class="cs-filter__hjaelp">
            Søger i specifikationerne, sammen med de filtre du har valgt.
        </p>
    </div>
</template>

<script setup>
import { onBeforeUnmount, ref, watch } from 'vue';
import { alleAktiveFiltre } from '@/Components/FilterManager.vue';

const emit = defineEmits(['filterUpdated']);
const props = defineProps(['filter', 'urlParams', 'categoryName']);

// Et eksempel der passer til kategorien er mere sigende end "søg her".
const eksempel = 'asus';

function fraUrl() {
    if (!props.urlParams) return '';

    return props.urlParams.get(String(props.filter.id)) || '';
}

const tekst = ref(fraUrl());
let ventetid = null;

watch(() => (props.urlParams ? props.urlParams.get(String(props.filter.id)) : ''), (ny) => {
    if ((ny || '') !== tekst.value) tekst.value = ny || '';
});

watch(tekst, () => {
    if (ventetid) clearTimeout(ventetid);

    // Kort nok til at føles med, langt nok til ikke at søge på hvert bogstav.
    ventetid = setTimeout(soegNu, 450);
});

onBeforeUnmount(() => {
    if (ventetid) clearTimeout(ventetid);
});

function soegNu() {
    if (ventetid) {
        clearTimeout(ventetid);
        ventetid = null;
    }

    const v = tekst.value.trim();

    /*
     * ALLE aktive filtre sendes med, ikke kun mit eget.
     *
     * updateQueryParamsAndReload sletter enhver parameter der ikke står i
     * listen. Sendte jeg kun min egen, forsvandt socket, kapacitet og alt
     * andet brugeren havde valgt: "AM5" gav 113 varer, og "AM5 + wifi" gav
     * 131, fordi socket-valget blev ryddet undervejs.
     *
     * Tom tekst fjerner mit eget filter og lader resten stå.
     */
    emit('filterUpdated', alleAktiveFiltre(props.urlParams, props.filter.id, v));
}

function ryd() {
    tekst.value = '';
    soegNu();
}
</script>

<style scoped>
.cs-filter__title {
    font-weight: 600;
    color: var(--pc-text-primary);
    margin-bottom: 6px;
}

.cs-filter__form {
    position: relative;
    display: flex;
}

.cs-filter__input {
    width: 100%;
    padding: 6px 26px 6px 10px;
    background: var(--pc-bg-tertiary);
    border: 1px solid var(--pc-border);
    border-radius: var(--pc-radius, 0.375rem);
    color: var(--pc-text-primary);
    font-size: var(--pc-text-sm, 0.875rem);
}

.cs-filter__input:focus {
    outline: none;
    border-color: var(--pc-accent);
}

.cs-filter__ryd {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--pc-text-muted);
    font-size: 1.1rem;
    line-height: 1;
    cursor: pointer;
}

.cs-filter__hjaelp {
    margin: 6px 0 0;
    font-size: var(--pc-text-xs, 0.75rem);
    color: var(--pc-text-muted, #8a8a8a);
}
</style>
